import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const steps = [{
  n: '1',
  title: 'Get your Reader-to-Revenue Score',
  line: '8 questions about what happens after someone reads your book.'
}, {
  n: '2',
  title: 'Audit the reader path',
  line: 'A deeper look at whether the path is worth building.'
}, {
  n: '3',
  title: 'Decide whether to build',
  line: 'No pressure. Decide once the opportunity is clear.'
}];
export function ScoreAuditBuild() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paperDark" width="default" data-id="element-921" data-mp="2hcmxxh0ah25l">
      <div className="mx-auto max-w-2xl text-center" data-id="element-922" data-mp="2cetrcmv2q64s">
        <Reveal data-id="element-923" data-mp="2cebnp5630pmu">
          <Eyebrow data-id="element-924" data-mp="2cgxx7acj9f7p">How it works</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-925" data-mp="15zas50kyy9gs">
            Get the score before you
            <br data-id="element-926" data-mp="10ywtua966dvy" />
            <span className="italic text-seaglass" data-id="element-927" data-mp="10yd9kmw1rder">decide what to build.</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} data-id="element-928" data-mp="18f5skv27ynif">
        <div className="mt-14 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-929" data-mp="1cj3rb4nmtway">
          {steps.map(step => <div key={step.n} className="relative rounded-3xl border border-gray-200 bg-white p-7 text-center" data-id="element-930" data-mp="yj2q1o3ggmuy">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-seaglass font-serif text-xl text-white" data-id="element-931" data-mp="13hdybue3qpb2">
                {step.n}
              </div>
              <h3 className="mt-5 font-serif text-xl text-navy" data-id="element-932" data-mp="tjpv0g2fk9ha">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-text-muted" data-id="element-933" data-mp="tlkf5s5vnxkb">
                {step.line}
              </p>
            </div>)}
        </div>
      </Reveal>

      <Reveal delay={0.15} data-id="element-934" data-mp="krxm49t218et">
        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-935" data-mp="kp1nskdaohpu">
          <Cta variant="primary" showArrow onClick={openDiagnostic} className="px-10 py-4 text-lg" data-id="element-936" data-mp="5vgadhgydrrq">
            Get Your Reader-to-Revenue Score
          </Cta>
          <p className="text-base font-medium text-text-muted" data-id="element-937" data-mp="3ntr4vsoo9ckr">
            Start with the Score. The rest follows only if it fits.
          </p>
        </div>
      </Reveal>
    </SectionBand>;
}